import { render, staticRenderFns } from "./HuanchongIdLight.vue?vue&type=template&id=6a16e7a6&scoped=true"
import script from "./HuanchongIdLight.vue?vue&type=script&lang=js"
export * from "./HuanchongIdLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16e7a6",
  null
  
)

export default component.exports